import {
  CreateDayDelayEntity,
  DayDelayEntity,
} from '@/pages/privatePages/dayDelay/types';
import { BaseService } from './base.service';

class DayDelayServiceClass extends BaseService<
  'dayDelay',
  DayDelayEntity,
  CreateDayDelayEntity
> {
  constructor() {
    super('day-delay');
  }
}
export const dayDelayService = new DayDelayServiceClass();
